import React, { memo } from 'react';
import type { FavoriteItemsType, RecentItemsType } from './types.tsx';
import { RenderRecentSection } from './recent-section/index.tsx';
import { RenderStarredSection } from './starred-section/index.tsx';
import { RenderMostRecentProjectSection } from './most-recent-project-section/index.tsx';

const Nav4ProjectsSectionsInternal = ({
	favoriteItems,
	recentItems,
	mostRecentProjectItem,
	canCreateProject,
}: {
	favoriteItems: FavoriteItemsType;
	recentItems: RecentItemsType;
	mostRecentProjectItem: React.JSX.Element | null;
	canCreateProject: boolean | undefined | null;
}): React.JSX.Element => (
	<>
		<RenderStarredSection favoriteItems={favoriteItems} canCreateProject={canCreateProject} />
		<RenderRecentSection recentItems={recentItems} canCreateProject={canCreateProject} />
		<RenderMostRecentProjectSection projectItem={mostRecentProjectItem} />
	</>
);

export const Nav4ProjectsSections: React.MemoExoticComponent<
	({
		favoriteItems,
		recentItems,
		mostRecentProjectItem,
		canCreateProject,
	}: {
		favoriteItems: FavoriteItemsType;
		recentItems: RecentItemsType;
		mostRecentProjectItem: React.JSX.Element | null;
		canCreateProject: boolean | undefined | null;
	}) => React.JSX.Element
> = memo(Nav4ProjectsSectionsInternal);
